import React from 'react';
import ServiceListItem from '../../../Domain/ServiceListItem';
import ShowEntityData from '../../../Elements/ShowEntityData';
import ServiceItemService from '../../../Services/ServiceItemService';

export default class ServiceDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    const serviceId = urlParams.get('id');

    this.state = {
      serviceId,
      loading: true,
    };
  }

  render() {
    return (
      <ShowEntityData
        itemId={this.state.serviceId}
        entityName='Assignment Payment Details'
        type={ServiceListItem}
        serviceGetByIdFunction={ServiceItemService.GetServiceItemById}
        emptyFieldsEnabled={true}
      />
    );
  }
}
